<template>
  <div class="login">
    <div class="container"> 
      <img src="../assets/logo_l@svg.svg" alt="六角西餐聽" class="logo" />
      <p class="subtitle">享受美食好味道</p>
      <form class="form">
        <h2 class="title">LOGIN</h2>
        <label>Email Address*<br><input type="email" placeholder="Email..." required></label>
        <label>Password*<br><input type="password" placeholder="Password..." required></label>
        <a href="#" class="forget">忘記密碼 ?</a>
        <div class="btnGroup">
          <button class="signupBtn"><router-link to="/signup">註冊</router-link></button>
          <button class="loginBtn">登入</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loginPage'
  }
</script>

<style lang="scss" scoped>
  .login {
    padding: 50px 0;
    background-color: #EFE9E7;
    .container {
      width: 300px; 
    }
  }
  .logo {
    display: block;
    margin: 0 auto;
  }
  .subtitle {
    margin-top: 5px;
    color: #3D1101;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }
  .form {
    margin-top: 35px;
    padding: 15px;
    border-top: 3px solid #FF5E45;
    box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.16);
    .title {
      font-size: 18px;
    }
    label {
      display: inline-block;
      width: 100%;
      margin-top: 16px;
      color: #3D1101;
    }
    input {
      height: 32px;
      width: 100%;
      margin-top: 3px;
      padding: 0 9px;
      border: 1px solid #CCCCCC;
      border-radius: 3px;
      box-shadow: inset 0px 1px 0px 0px #ECECEC;
      font-family: 'fontello';
    }
    .forget {
      color: #FF5E45;
      font-size: 14px;
    }
    .btnGroup {
      display: flex;
      justify-content: space-between;
      margin-top: 2rem;
      button {
        width: 125px;
        height: 2rem;
        padding: 6px 27px;
        border: none;
        border-radius: 3px;
      }
      .signupBtn {
        background: rgba(0,0,0,0.35);
        a {
          display: block;
          color: #fff;
        }
      }
      .loginBtn {
        background: #F56C23;
        color: #fff;
      }

    }
  }
</style>


// WEBPACK FOOTER //
// src/components/loginPage.vue